import { render, staticRenderFns } from "./DPH.vue?vue&type=template&id=003066c1"
import script from "./DPH.vue?vue&type=script&lang=js"
export * from "./DPH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports